export const codingSheetsFilters = [
  // {
  //   text: "Discuss Coding Sheets",
  //   id: 0,
  // lock: true,
  // },
  {
    text: "Striver's SDE Sheet",
    domainFilter: "striver-sde-sheet",
    id: 1,
    lock: false,
  },
  {
    text: "Love Babbar",
    domainFilter: "love-babbar",
    id: 2,
    lock: false,
  },
  {
    text: "Apna College",
    domainFilter: "apna-college",
    id: 3,
    lock: false,
  },
  {
    text: "Fraz SDE Sheet",
    domainFilter: "fraz-sde-sheet",
    id: 4,
    lock: false,
  },
  {
    text: "Blind 75",
    domainFilter: "blind-75",
    id: 5,
    lock: false,
  },
  {
    text: "Leetcode Top Interview Questions",
    domainFilter: "leetcode-top-interview-questions",
    id: 6,
    lock: false,
  },
  {
    text: "Neetcode 150",
    domainFilter: "neetcode-150",
    id: 7,
    lock: true,
  },
  {
    text: "Neetcode 400",
    domainFilter: "neetcode-400",
    id: 8,
    lock: true,
  },
  {
    text: "Striver A2Z",
    domainFilter: "striver-a2z",
    id: 9,
    lock: true,
  },
];
